import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';

const Antetituloh4 = styled.h4`
	margin: 0 auto;
   margin-top: 1em;
   color: ${colors.white};
   font-weight: 300;
   text-transform: uppercase;
   font-family: 'D-DinExp';
   letter-spacing: 0.05em;
   font-size: 0.9em;
`;

const Antetitulo = ({ contenido }) => (
	<div>
		<Antetituloh4>{contenido}</Antetituloh4>
	</div>
);

export default Antetitulo;



// WEBPACK FOOTER //
// ./src/components/Antetitulo.js